import script from "./EnifClubDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./EnifClubDocument.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__